module.exports = __webpack_public_path__ + "static/testing-968307ffacccb49ee6f65c3efb70ffc8.gif";